import { render, staticRenderFns } from "./ReferenciaColores.vue?vue&type=template&id=9f86f0f0"
import script from "./ReferenciaColores.vue?vue&type=script&lang=js"
export * from "./ReferenciaColores.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports